import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/forwardhub/commonconfig'
import pathMap from 'src/paths/PathMap_ForwardHub'

class CommonConfigRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.COMMON_CONFIG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.COMMON_CONFIG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.COMMON_CONFIG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.COMMON_CONFIG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default CommonConfigRoute
